import { baseAxios, axiosInstance } from "api/axios";
import axios from "axios";
import { Auth } from "aws-amplify";
import { routesEnum } from "pages/Routes";
import { IChangePasswordRequest, IChangePasswordResponse, INonInvestorInterest } from "./types";

export const SignIn = async (request: any): Promise<any> => {
	const data = await baseAxios.post(`/users/login`, request);
	return data;
};

export const SignUp = async (request: any): Promise<any> => {
	const data = await baseAxios.post(`/lead`, request);
	return data;
};

export const changePassword = async (
	request: IChangePasswordRequest,
): Promise<IChangePasswordResponse> => {
	const { data } = await baseAxios.post(`/user/password`, request);
	return data;
};

export const addNonInvestorInterest = async (request: INonInvestorInterest): Promise<any> => {
	const { data } = await axiosInstance.post(
		`/user/investor/addInterest/${request.issuance_id}`,
		request,
	);
	return data;
};

export const addInvestorInterest = async (request: INonInvestorInterest): Promise<any> => {
	const { data } = await axiosInstance.post(
		`/user/${request.user_id}/investor/addInterest/${request.issuance_id}`,
		request,
	);
	return data;
};

export const logout = async (): Promise<any> => {
	return await axios.post(`${process.env.WEB_API_URL}/users/token/clear`, {}, { withCredentials: true });
};

export const logoutAndRedirect = async (returnUrl?: string): Promise<void> => {
	try {
		await logout();
	} finally {
		await Auth.signOut().catch(() => undefined);
		const target = new URL(routesEnum.investorLoginV2, window.location.origin);
		if (returnUrl?.startsWith("/") && !returnUrl.startsWith("//")) {
			target.searchParams.set("url", returnUrl);
		}
		window.location.replace(target.toString());
	}
};

export const refreshToken = async (): Promise<any> => {
	const res = await axios
		.post(`${process.env.WEB_API_URL}/users/token/refresh`, {}, { withCredentials: true })
		.catch((error) => {
			window.location.href = routesEnum.investorLoginV2;
			return error;
		});
	const { data } = res;
	return data;
};
